import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { PopoverContentComponent } from './popover-content.component';



@NgModule({
  declarations: [PopoverContentComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule
  ]
})
export class PopoverContentModule { }
